import CheckCircle from "@mui/icons-material/CheckCircleOutline";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { ModalDialogTransition } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useFcNavigate } from "~/hooks/useFcNavigate";
import { mixpanelTrack, useMixpanelModalName } from "~/lib/mixpanel-tracking";

type CompletionModal = {
  isOpen: boolean;
};

export function CompletionModal(props: CompletionModal): React.ReactElement {
  const { isOpen } = props;
  const trackedModalName = useMixpanelModalName("Pick Tasks Completion");

  const { t } = useTranslation();
  const navigate = useFcNavigate();

  const handlePickAnotherBatch = (): void => {
    mixpanelTrack({
      trackedPageName: trackedModalName,
      label: "Pick Another Batch",
      type: "Button Click"
    });
    navigate("/pick-batches");
  };

  const handleStageCarts = (): void => {
    mixpanelTrack({
      trackedPageName: trackedModalName,
      label: "Stage Carts",
      type: "Button Click"
    });
    navigate("/carts");
  };

  return (
    <div className="CompletionModal">
      <Dialog
        open={isOpen}
        slots={{
          transition: ModalDialogTransition
        }}
        keepMounted
        fullWidth
        maxWidth="sm"
        aria-labelledby="completion"
        aria-describedby="redirect"
      >
        <DialogTitle>{t("totes for this batch are all staged")}</DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center"
          }}
        >
          <CheckCircle style={{ fontSize: 160 }} color="info" />
        </Box>
        <DialogActions style={{ justifyContent: "space-between" }}>
          <Button onClick={handlePickAnotherBatch} color="primary">
            {t("pick another batch")}
          </Button>
          <Button onClick={handleStageCarts} color="primary">
            {t("stage carts")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
